import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=2b81a592&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=ts&"
export * from "./Contact.vue?vue&type=script&lang=ts&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=2b81a592&prod&lang=scss&scoped=true&"
import style1 from "./Contact.vue?vue&type=style&index=1&id=2b81a592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81a592",
  null
  
)

export default component.exports